import React from 'react';
// import Layout from 'layout';
// import VehiculoSii from './VehiculoSii.js'
import Contribuyente from './Contribuyente.js'

import { authenticationService } from 'auth/authenticationService.js'

import { withRouter } from 'react-router-dom'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LogsPermiso from './LogsPermiso.js';
import DetallePago from './DetallePago.js';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
// import withRouter  from 'adds/router/withRouter.js';
import { RutValidator } from "adds/RutValidator.js"

import {
  Box,
  Typography,
  // Paper,
  Button,
  Alert,
  Chip,
  Divider,
  TextareaAutosize,
  Grid,
  Card, CardContent,
  Switch, FormControlLabel,
  Radio, FormControl, FormLabel, RadioGroup,
  Input, TextField, CircularProgress,
  Table, TableHead, TableBody, TableRow, TableCell, TableContainer,
  Collapse, IconButton, TablePagination,
  //  Dialog, DialogContent, DialogActions


} from '@mui/material';


// import { borders } from '@mui/system';
// import EditIcon from '@mui/icons-material/Edit';
// import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
// import CompareArrowsIcon from '@mui/icons-material/CompareArrows';


import NumberFormat from 'react-number-format';

import DownloadIcon from '@mui/icons-material/Download';
import CachedIcon from '@mui/icons-material/Cached';
import EmailIcon from '@mui/icons-material/Email';
// import SearchIcon from '@mui/icons-material/Search';

import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
// import { isCompositeComponent } from 'react-dom/test-utils';
// import { StopRounded } from '@mui/icons-material';


const MULTAS_POR_PAGINA = 20;

class Permiso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Filas de multas desplegadas (acordeón), por multa_en_permiso_uuid
      multas_abiertas: {},
      // Página actual de la tabla de multas (20 por página)
      multas_pagina: 0,
      html: {
        edit: 'edit' in this.props && this.props.edit ? true : false,
        create: false,
        error_prt: null,
        loading: false,
        loading_notificacion: false,
        loading_consulta_pago: false,
        editar_comentario_interno: false,
      },

      data: this.props.permiso,
      vehiculo: 'vehiculo' in this.props && this.props.vehiculo ? this.props.vehiculo : this.props.permiso.vehiculo,
      comentario_notificacion: '',

      error: {
        algo: false
      },
      feedback: {
        algo: ''
      },

      dialog_sii: {
        open: false,
      }
    };


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSetup = this.handleSetup.bind(this);

    this.handleLoad = this.handleLoad.bind(this);
    this.toBase64 = this.toBase64.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleMultaFile = this.handleMultaFile.bind(this);

    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);

    this.handleRadioMultaChange = this.handleRadioMultaChange.bind(this);
    this.handleRadioMultaChange = this.handleRadioMultaChange.bind(this);

    this.openDialogSii = this.openDialogSii.bind(this);
    this.closeDialogSii = this.closeDialogSii.bind(this);
    this.handleImportSii = this.handleImportSii.bind(this);
    this.notificarEstado = this.notificarEstado.bind(this);
    this.handleInputChangeNotificacion = this.handleInputChangeNotificacion.bind(this);
    this.consultaPago = this.consultaPago.bind(this);


    this.handleEditarComentario = this.handleEditarComentario.bind(this);
    this.handleUpdateTextarea = this.handleUpdateTextarea.bind(this);
  }

  componentDidUpdate(prevProps) {
    if ('vehiculo' in this.props && this.props.vehiculo && this.props.vehiculo.vehiculo_uuid) {
      // console.log(this.props)
      let prop_name = 'permiso'
      const matches = (obj, source) =>
        Object.keys(source).every(key => obj.hasOwnProperty(key) && obj[key] === source[key]);
      if (this.props[prop_name] && prevProps[prop_name] &&
        !matches(this.props[prop_name], prevProps[prop_name])) {
        if (this.state.data) {
          this.handleSubmit();
        }
      }
      prop_name = 'vehiculo';
      if (this.props[prop_name] && prevProps[prop_name] &&
        !matches(this.props[prop_name], prevProps[prop_name])) {
        if (this.state.data) {
          this.handleSubmit();
        }
      }
    }
  }

  componentDidMount() {
    this.handleSetup();
  }
  handleSetup() {
    console.log(this.state.html)
    if (this.state.html.edit) {
      if (this.state.data !== null && this.state.data.permiso_uuid !== '') {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            create: false,
          }
        }));
      }
      else {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            create: true,
          }
        }));
      }
    }
  }

  handleLoad() {
    authenticationService.fetchApi({
      url: '/permisos/permiso/' + this.state.data.permiso_uuid,
      method: 'GET',
    })
      .then(result => {
        this.setState({
          data: result,
          vehiculo: result.vehiculo
        }, () => {
          this.setState(prevState => ({
            html: {
              ...prevState.html,
              loading: false,
              create: false,
            }
          }), () => {
            console.log(this.state.html)
          });
        });

      })
      .catch(err => {

      });
  }
  notificarEstado(event, tipo = null) {
    let params = {}
    if (event) {
      event.preventDefault();
    }

    params['permiso_uuid'] = this.state.data.permiso_uuid
    params['tipo'] = tipo
    params['comentario'] = this.state.comentario_notificacion

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading_notificacion: true
      }
    }));
    // console.log(data)
    authenticationService.fetchApi({
      url: '/permisos/notificar_estado/',
      method: 'POST',
      body: JSON.stringify(params),
    })
      .then(result => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            loading_notificacion: false
          },
          comentario_notificacion: ''
        }), () => {
          this.handleSubmit();
        });

      })
      .catch(err => {

      });
  }

  consultaPago(event) {
    let params = {}
    if (event) {
      event.preventDefault();
    }

    params['permiso_uuid'] = this.state.data.permiso_uuid

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading_consulta_pago: true
      }
    }));

    authenticationService.fetchApi({
      url: '/permisos/consultar_pago/',
      method: 'POST',
      body: JSON.stringify(params),
    })
      .then(result => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            loading_consulta_pago: false
          },
        }), () => {
          this.handleSubmit();
        });

      })
      .catch(err => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            loading_consulta_pago: false
          },
        }));
      });
  }

  handleInputChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;
    currentState[name] = value;

    this.setState({ data: currentState });

  }
  handleInputChangeNotificacion(event) {
    // const { data } = { ...this.state };
    // const currentState = data;
    const { value } = event.target;
    // currentState[name] = value;

    // this.setState({ comentario_notificacion: value });
    this.setState(prevState => ({
      comentario_notificacion: value
    }), () => {
    });

  }

  toBase64(file) {
    return (
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    )
  }



  handleDownloadFile(event, file_url) {
    console.log("FILE URL ------>: ", file_url);

    event.preventDefault();
    var fetch_params = {
      url: '/permisos/uploads/',
      method: 'POST',
      body: JSON.stringify({ relative_path: file_url }),
      ContentType: 'file'
    }

    let file_name_array = file_url.split('/')
    console.log(file_name_array)
    let file_name = file_name_array[file_name_array.length - 1]
    // console.log(file_name)
    authenticationService.fetchApi(fetch_params)
      .then(result => {
        result.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");

          a.href = url;
          a.download = file_name;
          a.click();
        });
      })
      .catch(err => {

      });
  }

  handleFile(event) {
    const { name, files } = event.target
    const file = files[0];
    console.log(file.type)

    if (file.type !== undefined && ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
      this.toBase64(file).then(encodedFile => {
        this.setState(prevState => ({
          data: {
            ...prevState.data,
            [name]: encodedFile
          }
        }), () => {
          this.handleSubmit(null, { 'field': name, [name]: encodedFile });
        });
      });

      this.setState(prevState => ({
        error: {
          ...prevState.error,
          [name]: false
        }
      }));
    }
    else {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          [name]: true
        }
      }));
    }
  }

  handleMultaFile(event, index) {
    // console.log(event.target)
    const { name, id, files } = event.target
    const file = files[0];

    let params = {
      'field': name,
      'multa_en_permiso_uuid': id,
    }
    if (file.type !== undefined && ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
      this.toBase64(file).then(encodedFile => {
        params[name] = encodedFile
        this.handleSubmit(null, params);
      });

      this.setState(prevState => ({
        error: {
          ...prevState.error,
          [name + '_' + id]: false
        }
      }));
    }
    else {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          [name + '_' + id]: true
        }
      }));
    }
  }

  handleSwitchChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, checked } = event.target;
    // console.log(name);
    currentState[name] = checked;

    this.setState({ data: currentState }, () => {
      this.handleSubmit(null, { 'field': name, [name]: checked });
    });
  }

  handleRadioChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;
    // console.log(name);
    currentState[name] = value;

    this.setState({ data: currentState }, () => {
      this.handleSubmit(null, { 'field': name, [name]: value });
    });
  }

  handleSwitchMultaChange(event, index) {
    const { data } = { ...this.state };
    const currentState = data;
    const { id, name, checked } = event.target;


    currentState['multas'][index][name] = checked;


    let params = {
      'field': name,
      'multa_en_permiso_uuid': id,
      [name]: checked
    }

    // Al marcarla como pagada se despliega su detalle (comprobante y validación)
    this.setState(prevState => ({
      data: currentState,
      multas_abiertas: { ...prevState.multas_abiertas, [id]: checked }
    }), () => {
      this.handleSubmit(null, params);
    });
  }

  handleRadioMultaChange(event, index, multa_uuid) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;

    console.log(event.target)

    currentState['multas'][index][name] = value;


    let params = {
      'field': name,
      'multa_en_permiso_uuid': multa_uuid,
      [name]: value
    }

    this.setState({ data: currentState }, () => {
      this.handleSubmit(null, params);
    });
  }


  handleSubmit(event, params = {}, reload = false) {
    return new Promise((resolve, reject) => {
      if (event) {
        event.preventDefault();
      }

      if ('create' in params) {
        params['vehiculo_uuid'] = this.props.vehiculo.vehiculo_uuid
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            loading: true,
          }
        }));
      }

      else {
        params['permiso_uuid'] = this.state.data.permiso_uuid
      }

      // console.log(this.state.html)
      // console.log(data)
      authenticationService.fetchApi({
        url: '/permisos/permiso/',
        method: 'POST',
        body: JSON.stringify(params),
      })
        .then((result) => {
          this.setState({ data: result }, () => {
            this.handleSetup()
            return resolve(true)
          })
          if (params['vehiculo_sii_id']) {
            this.setState({ dialog_sii: { open: false } })
          }
          return resolve(true)
        })
        .catch(err => {
          return reject(false)
        });

    })
  }
  openDialogSii() {
    this.setState({ dialog_sii: { open: true } }, () => {
      // this.handleLoad()
    })
  }
  closeDialogSii() {
    this.setState({ dialog_sii: { open: false } }, () => {
      // this.handleLoad()
    })
  }
  handleImportSii(value) {
    this.handleSubmit(null, { 'vehiculo_sii_id': value });
  }
  handleEditarComentario(editar) {
    if (editar) {
      this.setState(prevState => ({ html: { ...prevState.html, editar_comentario_interno: true } }))
    }
    else {
      this.setState(prevState => ({ html: { ...prevState.html, editar_comentario_interno: false } }))
    }
  }
  handleUpdateTextarea(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;
    // console.log(name, value)
    currentState[name] = value;
    this.setState({ data: currentState })
  }
  // Página de multas válida para la cantidad actual (por si cambia el permiso o sus multas)
  paginaMultas() {
    const total = this.state.data && this.state.data.multas ? this.state.data.multas.length : 0;
    const ultima = Math.max(0, Math.ceil(total / MULTAS_POR_PAGINA) - 1);
    return Math.min(this.state.multas_pagina, ultima);
  }

  render() {
    return (
      <Box>
        <Box>
          {this.state.html.edit &&
            this.state.html.create &&

            <Box p={1} textAlign='center'>
              <Button startIcon={this.state.html.loading ? <CircularProgress /> : <AddCircleOutlineIcon />}
                disabled={this.state.html.loading ? true : false}
                onClick={event => this.handleSubmit(event, { 'create': true })} color='primary' variant='contained'>
                Crear permiso para el proceso vigente
              </Button>
            </Box>


          }
          {this.state.data &&


            <Box>

              <Box mt={2} mb={2}>
                <Typography variant='h5'>
                  Permiso año vigente {this.state.data.agno_proceso && this.state.data.agno_proceso}
                </Typography>
                <Box>

                  {this.state.html.edit &&
                    this.state.html.editar_comentario_interno &&
                    <Box p={1} sx={{ backgroundColor: "#EEEEEE" }}>
                      <Typography variant='overline'>
                        Comentario interno
                      </Typography>
                      <Box>
                        <TextareaAutosize aria-label="Comentario al permiso"
                          minRows={5}
                          name='comentario_interno'
                          placeholder="Comentario al permiso"
                          style={{ minWidth: 500 }}
                          onChange={this.handleUpdateTextarea}
                          value={this.state.data.comentario_interno ? this.state.data.comentario_interno : ''}
                        />

                      </Box>
                      <Button onClick={event => this.handleSubmit(null, { 'field': 'comentario_interno', 'comentario_interno': this.state.data.comentario_interno })}
                        variant='contained'>
                        Guardar Comentario
                      </Button>
                    </Box>
                  }
                  {this.state.html.edit &&
                    !this.state.html.editar_comentario_interno &&
                    <Box p={1} sx={{ backgroundColor: "#EEEEEE" }}>
                      <Typography variant='overline'>
                        Comentario interno
                      </Typography>
                      <pre>
                        <Typography variant='body2' color='primary'>
                          {this.state.data.comentario_interno && this.state.data.comentario_interno !== '' ? this.state.data.comentario_interno : 'Sin cometario'}
                        </Typography>
                      </pre>
                      <Button onClick={event => this.handleEditarComentario(true)}
                        startIcon={<EditIcon />}>
                        Editar Comentario
                      </Button>
                    </Box>

                  }



                </Box>

                <Box pb={2} pt={1}>
                  <Alert severity={this.state.data.estado_consolidado === 0 ? 'warning' :
                    this.state.data.estado_consolidado === 1 ? 'success' :
                      this.state.data.estado_consolidado === 2 ? 'error' :
                        this.state.data.estado_consolidado === 3 ? 'info' :
                          this.state.data.estado_consolidado === 4 ? 'success' :
                            this.state.data.estado_consolidado === 5 ? 'warning' :
                              this.state.data.estado_consolidado === 6 ? 'warning' :
                              'info'}
                    style={{ minHeigth: '100px' }}
                    variant={[4, 5, 6].includes(this.state.data.estado_consolidado) ? 'filled' : 'standard'}>
                    <Typography variant='h6'>
                      Estado final del permiso
                    </Typography>
                    <Box>
                      <strong>Estado consolidado: </strong> {this.state.data.estado}
                    </Box>
                    <Box>
                      <Grid container>
                        <Grid item xs={6}>
                          {this.state.html.edit &&
                            <Box>
                              <Button startIcon={<AccessibilityNewIcon />}
                                onClick={event => this.handleSubmit(event, { 'me': true })}
                                variant='contained'
                                size='small'
                              >
                                Asignarme este permiso
                              </Button>
                            </Box>
                          }
                          <Box>
                            <Typography variant='overline'>Último agente editor del permiso</Typography>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>: {this.state.data.agente}</Typography>
                          </Box>
                          <Box>
                            <Typography variant='overline'>Última modificación del permiso</Typography>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>: {(new Date(this.state.data.fecha_actualizacion)).toLocaleString('es-CL')}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} align='right'>
                          <LogsPermiso logs={'logs' in this.state.data ? this.state.data.logs : null} />
                        </Grid>


                        <Grid item xs={6}>
                          <Box>
                            <Typography variant='caption'>Última fecha consulta pago</Typography>
                            <Typography variant='caption' sx={{ fontWeight: 'bold' }}>: {this.state.data.fecha_consulta_webservice ? (new Date(this.state.data.fecha_consulta_webservice)).toLocaleString('es-CL') : 'Sin consultar aún'}</Typography>
                          </Box>
                          {this.state.data.fecha_pago &&
                            <Box>
                              <Box>
                                <Typography variant='caption'>Fecha último pago en SMC</Typography>
                                <Typography variant='caption' sx={{ fontWeight: 'bold' }}>: {this.state.data.fecha_pago ? (new Date(this.state.data.fecha_pago)).toLocaleString('es-CL') : 'Sin consultar aún'}</Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>Monto total pagado</Typography>
                                <Typography variant='caption' sx={{ fontWeight: 'bold' }}>:&nbsp;
                                  <NumberFormat displayType={'text'}
                                    value={this.state.data.monto_pago ? this.state.data.monto_pago : ''}
                                    decimalScale={0}
                                    prefix={'$'} />

                                </Typography>
                              </Box>
                            </Box>
                          }
                        </Grid>
                        <Grid item xs={6} align='right'>
                          <Box pb={1}>
                            <DetallePago permiso_uuid={this.state.data.permiso_uuid} />
                          </Box>
                          {this.state.html.edit &&
                            [0, 1, 2, 3, 6].includes(this.state.data.estado_consolidado) &&
                            <Button onClick={this.consultaPago}
                              variant='contained'
                              startIcon={this.state.html.loading_consulta_pago ? <CircularProgress size={20} /> : <SettingsInputAntennaIcon />}
                              disabled={this.state.html.loading_consulta_pago ? true : false}
                            >
                              Consultar Pago en SMC
                            </Button>
                          }
                        </Grid>
                        <Divider />
                        <Grid item xs={12}>
                          <Box sx={{ border: '1px solid #DDDDDD' }} p={1} mt={1}>
                            {
                              console.log(this.state)
                            }
                            {this.state.html.edit &&
                              [0, 1, 2, 3].includes(this.state.data.estado_consolidado) &&
                              <Box>
                                <Button startIcon={<PauseIcon />}
                                  onClick={event => this.handleSubmit(event, { 'forzar_estado': 5 })}
                                  variant='contained'
                                  color='secondary'
                                >
                                  Descartar este permiso
                                </Button>
                                <Box>
                                  <Typography variant={'caption'}>
                                    Al hacer click en este botón, el permiso quedará en estado Descartado. Se puede activar luego, en esta misma sección.
                                    También se activará si el contribuyente consulta el permiso en el sitio de permisosweb.renca.cl.
                                  </Typography>
                                </Box>
                              </Box>
                            }

                            {this.state.html.edit &&
                              [5].includes(this.state.data.estado_consolidado) &&
                              <Box>
                                <Button startIcon={<PlayArrowIcon />}
                                  onClick={event => this.handleSubmit(event, { 'forzar_estado': 0 })}
                                  variant='contained'
                                >
                                  Reactivar este permiso
                                </Button>
                                <Box>
                                  <Typography variant={'caption'}>
                                    Al hacer click en este botón, se reprocesará el estado de permiso.
                                  </Typography>
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Grid>
                      </Grid>

                    </Box>
                  </Alert>
                </Box>

              </Box>

              {
                /*****************************************
                  Contribuyente
                ******************************************/
              }

              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_contribuyente === 0 ? 'warning' :
                        this.state.data.estado_contribuyente === 1 ? 'success' :
                          this.state.data.estado_contribuyente === 2 ? 'error' :
                            this.state.data.estado_contribuyente === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Contribuyente asociado al Vehículo
                        </Typography>
                        <Box>
                          {this.state.data.estado_contribuyente === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_contribuyente === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_contribuyente === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_contribuyente === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_contribuyente}
                        </Box>

                      </Alert>
                    </Box>

                    {this.state.data &&
                      <Box>
                        <Box>
                          {'contribuyente' in this.state.data &&
                            <>
                              {/* {console.log('PreContribuyente',this.state.data)} */}
                              {/* {console.log('Contribuyente',this.state.data.contribuyente)} */}
                              <Contribuyente contribuyente={this.state.data.contribuyente ? this.state.data.contribuyente : null}
                                interno={true}
                                permiso={this.state.data}
                                updatePermiso={this.handleSubmit} />
                            </>
                          }
                        </Box>
                        {this.state.html.edit &&
                          this.state.data.contribuyente &&
                          this.state.data.estado_contribuyente !== 3 &&
                          !this.state.data.contribuyente.es_contribuyente_anterior &&
                          ![4, 5, 6].includes(this.state.data.estado_consolidado) &&

                          <Box p={2} m={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">Validar que la información de contribuyente sea correcta</FormLabel>
                              <RadioGroup
                                aria-label="gender"
                                name="contribuyente_validacion"
                                value={this.state.data.contribuyente_validacion}
                                onChange={this.handleRadioChange}
                              >
                                <FormControlLabel value={0} control={<Radio />} label="Aún sin validar" />
                                <FormControlLabel value={1} control={<Radio />} label="Validado" />
                                <FormControlLabel value={2} control={<Radio />} label="Rechazado" />
                              </RadioGroup>
                            </FormControl>
                          </Box>
                        }
                      </Box>
                    }
                  </CardContent>
                </Card>
              </Box>

              {
                /*****************************************
                 IDENTIFACION DEL AUTOMOVIL
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_identificacion === 0 ? 'warning' :
                        this.state.data.estado_identificacion === 1 ? 'success' :
                          this.state.data.estado_identificacion === 2 ? 'error' :
                            this.state.data.estado_identificacion === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Identificación del vehículo
                        </Typography>
                        <Box>
                          {this.state.data.estado_identificacion === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_identificacion === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_identificacion === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_identificacion === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_identificacion}
                        </Box>
                      </Alert>
                    </Box>


                    <Box p={1}>
                      <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                        ¿Es renovación de la misma comuna (permiso del año anterior es de Renca)?
                      </Typography>
                      <Box pl={2} sx={{ display: 'inline' }}>
                        <Chip size="small"
                          label={this.state.data.renovacion_status ? 'Si' : 'No'}
                          icon={(this.state.data.renovacion_status) ? <DoneIcon /> : <WarningIcon />}
                          style={(this.state.data.renovacion_status) ? { backgroundColor: 'lightgreen' } : {}}
                        />

                      </Box>
                      {this.state.html.edit &&
                        this.state.data.tipo === 'Renovación' &&
                        ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                        <Box>
                          <Typography variant='body2'>
                            Este vehículo es una renovación (el permiso del año pasado es de Renca). Sin embargo, si consideras que aún así es
                            necesario validar los antecedentes, los puedes exigir activando el siguiente switch.
                          </Typography>
                          <Box p={1}>
                            <FormControlLabel control={<Switch name='identificacion_exigir_documentos'
                              id='identificacion_exigir_documentos'
                              onChange={this.handleSwitchChange}
                              checked={this.state.data.identificacion_exigir_documentos}
                            />}
                              label="Exigir de igual forma documentos de padrón y permiso anterior." />
                          </Box>
                        </Box>
                      }
                      {this.state.data.tipo !== 'Renovación' &&

                        <Box>
                          <Typography variant='body2'>
                            Este vehículo no es una renovación del año pasado (permiso anterior no es de Renca), por lo cual es necesario adjuntar y validar el los documentos de padrón
                            y permiso de circulación anterior.
                          </Typography>
                        </Box>
                      }
                    </Box>

                    {(this.state.data.tipo !== 'Renovación' || this.state.data.identificacion_exigir_documentos) &&
                      <Grid container spacing={1}>
                        <Grid item md={6} sm={12}>
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Padrón del vehículo
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_padron_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_padron_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_padron_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />

                            </Box>

                            {this.state.data.archivo_padron &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Actualmente ya tienes un archivo de padrón cargado&nbsp;
                                </Typography>
                                <Button variant='contained' startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, this.state.data.archivo_padron)}>
                                  Descargar
                                </Button>
                              </Box>
                            }

                            {this.state.html.edit &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_padron_validacion) &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedPadronFile">
                                    <Input name="encodedPadronFile"
                                      id="encodedPadronFile"
                                      type="file"
                                      accept="image/*,.pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedPadronFile' in this.state.error && this.state.error.encodedPadronFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>

                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedPadronFile !== '' && this.state.data.encodedPadronFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }

                            {this.state.html.edit &&
                              this.state.data.archivo_padron &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                              <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                <FormControl component="fieldset">
                                  <FormLabel component="legend">Validar que el padrón adjunto es correcto</FormLabel>
                                  <RadioGroup
                                    aria-label="gender"
                                    name="archivo_padron_validacion"
                                    value={this.state.data.archivo_padron_validacion}
                                    onChange={this.handleRadioChange}
                                  >
                                    <FormControlLabel value={0} control={<Radio size="small" />} label="Aún sin validar" />
                                    <FormControlLabel value={1} control={<Radio size="small" />} label="Validado" />
                                    <FormControlLabel value={2} control={<Radio size="small" />} label="Rechazado" />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            }
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Permiso de ciculación anterior
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_permiso_anterior_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_permiso_anterior_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_permiso_anterior_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />

                            </Box>
                            {this.state.data.archivo_permiso_anterior &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Actualmente ya tienes un archivo de permiso anterior cargado&nbsp;
                                </Typography>
                                <Button variant='contained' startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, this.state.data.archivo_permiso_anterior)}>
                                  Descargar
                                </Button>
                              </Box>
                            }
                            {this.state.html.edit &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_permiso_anterior_validacion) &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar:&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedPermisoAnteriorFile">
                                    <Input name="encodedPermisoAnteriorFile"
                                      id="encodedPermisoAnteriorFile"
                                      type="file"
                                      accept="image/*,application/pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedPermisoAnteriorFile' in this.state.error && this.state.error.encodedPermisoAnteriorFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedPermisoAnteriorFile !== '' && this.state.data.encodedPermisoAnteriorFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }



                            {this.state.html.edit &&
                              this.state.data.archivo_permiso_anterior &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                              <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                <FormControl component="fieldset">
                                  <FormLabel component="legend">Validar que el permiso anterior adjunto es correcto</FormLabel>
                                  <RadioGroup
                                    aria-label="gender"
                                    name="archivo_permiso_anterior_validacion"
                                    value={this.state.data.archivo_permiso_anterior_validacion}
                                    onChange={this.handleRadioChange}
                                  >
                                    <FormControlLabel value={0} control={<Radio size="small" />} label="Aún sin validar" />
                                    <FormControlLabel value={1} control={<Radio size="small" />} label="Validado" />
                                    <FormControlLabel value={2} control={<Radio size="small" />} label="Rechazado" />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            }

                          </Box>
                        </Grid>
                      </Grid>
                    }

                  </CardContent>
                </Card>
              </Box>
              {
                /*****************************************
                  Tasacion SII
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_sii === 0 ? 'warning' :
                        this.state.data.estado_sii === 1 ? 'success' :
                          this.state.data.estado_sii === 2 ? 'error' :
                            this.state.data.estado_sii === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Tasación SII
                        </Typography>

                        <Box>
                          {this.state.data.estado_sii === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_sii === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_sii === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_sii === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_sii}
                        </Box>
                      </Alert>
                    </Box>

                    {this.state.html.edit &&
                      ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                      <Box>
                        <Box p={1}>
                          <FormControlLabel control={<Switch name='sii_es_nuevo'
                            id='sii_es_nuevo'
                            onChange={this.handleSwitchChange}
                            checked={this.state.data.sii_es_nuevo}
                          />}
                            label="Es un vehículo nuevo (año 2025-2026)" />
                        </Box>
                        <Box p={1}>
                          <FormControlLabel control={<Switch name='sii_exigir_documentos'
                            id='sii_exigir_documentos'
                            onChange={this.handleSwitchChange}
                            checked={this.state.data.sii_exigir_documentos}
                          />}
                            label="Exigir de igual forma factura del vehículo." />
                        </Box>
                      </Box>
                    }

                    {(this.state.data.sii_es_nuevo || this.state.data.sii_exigir_documentos) &&
                      <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                        <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                          Factura del vehículo
                        </Typography>
                        {this.state.data.archivo_sii &&
                          <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                            <Typography variant='overline'>
                              Actualmente ya tienes un archivo de factura cargado
                            </Typography>
                            <Box>
                              <Button startIcon={<DownloadIcon />}
                                onClick={event => this.handleDownloadFile(event, this.state.data.archivo_sii)}
                                variant='contained'>
                                Descargar archivo
                              </Button>
                            </Box>
                          </Box>
                        }
                        {this.state.html.edit &&
                          ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_sii_validacion) &&
                          <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                            <Typography variant='overline'>
                              Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                            </Typography>
                            <Box>
                              <label htmlFor="encodedSiiFile">
                                <Input name="encodedSiiFile"
                                  id="encodedSiiFile"
                                  type="file"
                                  accept="image/*,application/pdf"
                                  onChange={this.handleFile}
                                  style={{ display: 'none' }}
                                />
                                {'encodedSiiFile' in this.state.error && this.state.error.encodedSiiFile &&
                                  <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                }
                                <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                  {this.state.data.encodedSiiFile !== '' && this.state.data.encodedSiiFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                </Button>
                              </label>
                            </Box>
                          </Box>
                        }

                        {this.state.html.edit &&
                          this.state.data.archivo_sii &&
                          ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                          <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend">Validar que el documento de revisión técnica es correcto</FormLabel>
                              <RadioGroup
                                aria-label="archivo_sii_validacion"
                                name="archivo_sii_validacion"
                                value={this.state.data.archivo_sii_validacion}
                                onChange={this.handleRadioChange}
                              >
                                <FormControlLabel value={0} control={<Radio />} label="Aún sin validar" />
                                <FormControlLabel value={1} control={<Radio />} label="Validado" />
                                <FormControlLabel value={2} control={<Radio />} label="Rechazado" />
                              </RadioGroup>
                            </FormControl>
                          </Box>
                        }
                      </Box>
                    }
                  </CardContent>
                </Card>
              </Box>
              {
                /*****************************************
                  REVISION TECNICA
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_prt === 0 ? 'warning' :
                        this.state.data.estado_prt === 1 ? 'success' :
                          this.state.data.estado_prt === 2 ? 'error' :
                            this.state.data.estado_prt === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Revisión técnica
                        </Typography>

                        <Box>
                          {this.state.data.estado_prt === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_prt === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_prt === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_prt === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_prt}
                        </Box>
                      </Alert>
                    </Box>
                    <Grid container>

                      <Grid item md={6} sm={12}>
                        <Box p={1}>
                          <Box>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Estado de la revisión técnica por webservice
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.webservice_prt_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.webservice_prt_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.webservice_prt_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />
                            </Box>
                          </Box>
                          {this.state.html.edit &&
                            ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                            <Box>
                              <Button startIcon={<CachedIcon />}
                                onClick={event => this.handleSubmit(event, { 'reload_prt': true })}
                              >
                                Recargar revisión técnica
                              </Button>
                            </Box>
                          }
                          {this.state.data.prt &&
                            <Box>


                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Fecha consulta: &nbsp;</Box>
                                  {(new Date(this.state.data.prt.fecha_consulta)).toLocaleString('es-CL')}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Fecha de vencimiento revisión: &nbsp;</Box>
                                  {this.state.data.prt.revision_fecha_vencimiento}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>  Planta revisión técnica: &nbsp;</Box>
                                  {this.state.data.prt.revision_direccion_prt + ', ' + this.state.data.prt.revision_comuna_prt}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Código gases: &nbsp;</Box>
                                  {this.state.data.prt.gases_codigo_prt}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Resultado gases: &nbsp;</Box>
                                  {this.state.data.prt.gases_cod_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Mensaje gases: &nbsp;</Box>
                                  {this.state.data.prt.gases_mensaje_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Número certificado gases: &nbsp;</Box>
                                  {this.state.data.prt.gases_numero_certificado}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Código revisión técnica: &nbsp;</Box>
                                  {this.state.data.prt.revision_codigo_prt}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Resultado revisión técnica: &nbsp;</Box>
                                  {this.state.data.prt.revision_cod_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Mensaje revisión técnica: &nbsp;</Box>
                                  {this.state.data.prt.revision_mensaje_resultado}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Número certificado revisión técnica: &nbsp;</Box>
                                  {this.state.data.prt.revision_numero_certificado}
                                </Typography>
                              </Box>

                            </Box>
                          }
                        </Box>
                        {this.state.html.edit &&
                          ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                          this.state.data.webservice_prt_status &&
                          <Box p={1}>
                            <FormControlLabel control={<Switch name='prt_exigir_documentos'
                              id='prt_exigir_documentos'
                              onChange={this.handleSwitchChange}
                              checked={this.state.data.prt_exigir_documentos}
                            />}
                              label="Exigir de igual forma documentos de Revisión técnica." />
                          </Box>
                        }
                      </Grid>
                      {(this.state.data.prt_exigir_documentos || this.state.data.webservice_prt_status === false) &&
                        <Grid item md={6} sm={12}>

                          {this.state.html.edit &&
                            !this.state.data.sii_es_nuevo &&
                            <Box p={1}>
                              <FormControlLabel control={<Switch name='prt_es_homologacion'
                                id='prt_es_homologacion'
                                onChange={this.handleSwitchChange}
                                checked={this.state.data.prt_es_homologacion}
                              />}
                                label="Este vehículo tiene homologación" />
                            </Box>
                          }
                          <Box p={1}>
                            {!this.state.data.sii_es_nuevo && !this.state.data.prt_es_homologacion &&
                              <Box>
                                <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                                  <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                                    Comprobante de Revisión técnica
                                  </Typography>
                                  <Box pl={2} sx={{ display: 'inline' }}>
                                    <Chip size="small"
                                      label={this.state.data.archivo_revision_status ? 'Completo' : 'Incompleto'}
                                      icon={(this.state.data.archivo_revision_status) ? <DoneIcon /> : <WarningIcon />}
                                      style={(this.state.data.archivo_revision_status) ? { backgroundColor: 'lightgreen' } : {}}
                                    />
                                  </Box>

                                  {this.state.data.archivo_revision &&
                                    <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                      <Typography variant='overline'>
                                        Actualmente ya tienes un archivo cargado&nbsp;
                                      </Typography>
                                      <Box>
                                        <Button startIcon={<DownloadIcon />}
                                          onClick={event => this.handleDownloadFile(event, this.state.data.archivo_revision)}
                                          variant='contained'>
                                          Descargar archivo
                                        </Button>
                                      </Box>
                                    </Box>
                                  }
                                  {this.state.html.edit &&
                                    ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_revision_validacion) &&
                                    <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                      <Typography variant='overline'>
                                        Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                      </Typography>
                                      <Box>
                                        <label htmlFor="encodedRevisionFile">
                                          <Input name="encodedRevisionFile"
                                            id="encodedRevisionFile"
                                            type="file"
                                            accept="image/*,application/pdf"
                                            onChange={this.handleFile}
                                            style={{ display: 'none' }}
                                          />
                                          {'encodedRevisionFile' in this.state.error && this.state.error.encodedRevisionFile &&
                                            <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                          }
                                          <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                            {this.state.data.encodedRevisionFile !== '' && this.state.data.encodedRevisionFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                          </Button>
                                        </label>
                                      </Box>
                                    </Box>
                                  }
                                  {this.state.html.edit &&
                                    this.state.data.archivo_revision &&
                                    ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                                    <Box p={2} m={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                      <FormControl component="fieldset">
                                        <FormLabel component="legend">Validar que el documento de revisión técnica es correcto</FormLabel>
                                        <RadioGroup
                                          aria-label="archivo_revision_validacion"
                                          name="archivo_revision_validacion"
                                          value={this.state.data.archivo_revision_validacion}
                                          onChange={this.handleRadioChange}
                                        >
                                          <FormControlLabel value={0} control={<Radio />} label="Aún sin validar" />
                                          <FormControlLabel value={1} control={<Radio />} label="Validado" />
                                          <FormControlLabel value={2} control={<Radio />} label="Rechazado" />
                                        </RadioGroup>
                                      </FormControl>
                                    </Box>
                                  }
                                </Box>
                                <Box p={1} mt={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                                  <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                                    Comprobante de Gases
                                  </Typography>
                                  <Box pl={2} sx={{ display: 'inline' }}>
                                    <Chip size="small"
                                      label={this.state.data.archivo_gases_status ? 'Completo' : 'Incompleto'}
                                      icon={(this.state.data.archivo_gases_status) ? <DoneIcon /> : <WarningIcon />}
                                      style={(this.state.data.archivo_gases_status) ? { backgroundColor: 'lightgreen' } : {}}
                                    />
                                  </Box>
                                  <Box>
                                    {this.state.data.archivo_gases &&
                                      <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                        <Typography variant='overline'>
                                          Actualmente ya tienes un archivo cargado&nbsp;
                                        </Typography>
                                        <Box>
                                          <Button startIcon={<DownloadIcon />}
                                            onClick={event => this.handleDownloadFile(event, this.state.data.archivo_gases)}
                                            variant='contained'>
                                            Descargar archivo
                                          </Button>
                                        </Box>
                                      </Box>
                                    }
                                  </Box>

                                  {this.state.html.edit &&
                                    ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_gases_validacion) &&
                                    <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                      <Typography variant='overline'>
                                        Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                      </Typography>
                                      <Box>
                                        <label htmlFor="encodedGasesFile">
                                          <Input name="encodedGasesFile"
                                            id="encodedGasesFile"
                                            type="file"
                                            accept="image/*,application/pdf"
                                            onChange={this.handleFile}
                                            style={{ display: 'none' }}
                                          />
                                          {'encodedGasesFile' in this.state.error && this.state.error.encodedGasesFile &&
                                            <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                          }
                                          <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                            {this.state.data.encodedGasesFile !== '' && this.state.data.encodedGasesFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                          </Button>
                                        </label>
                                      </Box>
                                    </Box>
                                  }
                                  {this.state.html.edit &&
                                    this.state.data.archivo_gases &&
                                    ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                                    <Box p={2} m={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                      <FormControl component="fieldset">
                                        <FormLabel component="legend">Validar que el documento de gases es correcto</FormLabel>
                                        <RadioGroup
                                          aria-label="archivo_gases_validacion"
                                          name="archivo_gases_validacion"
                                          value={this.state.data.archivo_gases_validacion}
                                          onChange={this.handleRadioChange}
                                        >
                                          <FormControlLabel value={0} control={<Radio />} label="Aún sin validar" />
                                          <FormControlLabel value={1} control={<Radio />} label="Validado" />
                                          <FormControlLabel value={2} control={<Radio />} label="Rechazado" />
                                        </RadioGroup>
                                      </FormControl>
                                    </Box>
                                  }
                                </Box>
                              </Box>
                            }
                            {(this.state.data.sii_es_nuevo || this.state.data.prt_es_homologacion) &&
                              <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                                <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                                  Comprobante de Homologación
                                </Typography>
                                <Box pl={2} sx={{ display: 'inline' }}>
                                  <Chip size="small"
                                    label={this.state.data.archivo_homologacion_status ? 'Completo' : 'Incompleto'}
                                    icon={(this.state.data.archivo_homologacion_status) ? <DoneIcon /> : <WarningIcon />}
                                    style={(this.state.data.archivo_homologacion_status) ? { backgroundColor: 'lightgreen' } : {}}
                                  />
                                </Box>
                                {this.state.data.archivo_homologacion &&
                                  <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                    <Typography variant='overline'>
                                      Actualmente ya tienes un archivo cargado&nbsp;
                                    </Typography>
                                    <Box>
                                      <Button startIcon={<DownloadIcon />}
                                        onClick={event => this.handleDownloadFile(event, this.state.data.archivo_homologacion)}
                                        variant='contained'>
                                        Descargar archivo
                                      </Button>
                                    </Box>
                                  </Box>
                                }
                                {this.state.html.edit &&
                                  ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_homologacion_validacion) &&
                                  <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                    <Typography variant='overline'>
                                      Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                    </Typography>
                                    <Box>
                                      <label htmlFor="encodedHomologacionFile">
                                        <Input name="encodedHomologacionFile"
                                          id="encodedHomologacionFile"
                                          type="file"
                                          accept="image/*,application/pdf"
                                          onChange={this.handleFile}
                                          style={{ display: 'none' }}
                                        />
                                        {'encodedHomologacionFile' in this.state.error && this.state.error.encodedHomologacionFile &&
                                          <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                        }
                                        <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                          {this.state.data.encodedHomologacionFile !== '' && this.state.data.encodedHomologacionFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                        </Button>
                                      </label>
                                    </Box>
                                  </Box>
                                }
                                {this.state.html.edit &&
                                  this.state.data.archivo_homologacion &&
                                  ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                                  <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                    <FormControl component="fieldset">
                                      <FormLabel component="legend">Validar que el documento de homologación es correcto</FormLabel>
                                      <RadioGroup
                                        aria-label="archivo_homologacion_validacion"
                                        name="archivo_homologacion_validacion"
                                        value={this.state.data.archivo_homologacion_validacion}
                                        onChange={this.handleRadioChange}
                                      >
                                        <FormControlLabel value={0} control={<Radio size="small" />} label="Aún sin validar" />
                                        <FormControlLabel value={1} control={<Radio size="small" />} label="Validado" />
                                        <FormControlLabel value={2} control={<Radio size="small" />} label="Rechazado" />
                                      </RadioGroup>
                                    </FormControl>
                                  </Box>
                                }
                              </Box>
                            }

                          </Box>

                        </Grid>
                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Box>

              {
                /*****************************************
                  SOAP
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>
                    <Box p={1}>
                      <Alert severity={this.state.data.estado_soap === 0 ? 'warning' :
                        this.state.data.estado_soap === 1 ? 'success' :
                          this.state.data.estado_soap === 2 ? 'error' :
                            this.state.data.estado_soap === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Seguro Obligatorio
                        </Typography>
                        <Box>
                          {this.state.data.estado_soap === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_soap === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_soap === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_soap === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_soap}
                        </Box>
                      </Alert>
                    </Box>
                    <Grid container>

                      <Grid item md={6} sm={12}>

                        <Box p={1}>
                          <Box>
                            <Typography variant='overline'>
                              Estado del seguro obligatorio
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.webservice_soap_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.webservice_soap_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.webservice_soap_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />
                            </Box>
                          </Box>
                          {this.state.html.edit &&
                            ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                            <Box>
                              <Button startIcon={<CachedIcon />}
                                onClick={event => this.handleSubmit(event, { 'reload_soap': true })}
                              >
                                Recargar seguro obligatorio por webservice
                              </Button>
                            </Box>
                          }
                          {this.state.data.soap &&
                            <Box>

                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Fecha consulta: &nbsp;</Box>
                                  {(new Date(this.state.data.soap.created_at)).toLocaleString('es-CL')}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Fecha de vencimiento seguro: &nbsp;</Box>
                                  {this.state.data.soap.fecha_termino}
                                </Typography>
                              </Box>
                              {/* <Box>
                              <Typography variant='caption' color='primary'>
                              <Box sx={{display:'inline', fontWeight:'bold'}}>Rut Propietario: &nbsp;</Box>
                              {this.state.data.soap && this.state.data.soap.rut_propietario?RutValidator.format(this.state.data.soap.rut_propietario):''}
                              </Typography>
                            </Box> */}
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Empresa seguro: &nbsp;</Box>
                                  {this.state.data.soap.nombre_compania}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Rut empresa: &nbsp;</Box>
                                  {this.state.data.soap.rut_compania}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Patente: &nbsp;</Box>
                                  {this.state.data.soap.patente}
                                </Typography>
                              </Box>
                              {/* <Box>
                              <Typography variant='caption'>
                              <Box sx={{display:'inline', fontWeight:'bold'}}>Año fabricación: &nbsp;</Box>
                              {this.state.data.soap.agno_fabricacion}
                              </Typography>
                            </Box> */}
                              {/* <Box>
                              <Typography variant='caption'>
                              <Box sx={{display:'inline', fontWeight:'bold'}}>Número de folio: &nbsp;</Box>
                              {this.state.data.soap.nro_folio}
                              </Typography>
                            </Box> */}
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Número de poliza: &nbsp;</Box>
                                  {this.state.data.soap.nro_poliza}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant='caption'>
                                  <Box sx={{ display: 'inline', fontWeight: 'bold' }}>Ticket: &nbsp;</Box>
                                  {this.state.data.soap.ticket}
                                </Typography>
                              </Box>
                            </Box>
                          }
                        </Box>
                        {this.state.html.edit &&
                          this.state.data.webservice_soap_status &&
                          ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                          <Box p={1}>
                            <FormControlLabel control={<Switch name='soap_exigir_documentos'
                              id='soap_exigir_documentos'
                              onChange={this.handleSwitchChange}
                              checked={this.state.data.soap_exigir_documentos}
                            />}
                              label="Exigir de igual forma documentos de Seguro obligatorio." />
                          </Box>
                        }
                      </Grid>
                      {(this.state.data.soap_exigir_documentos || this.state.data.webservice_soap_status === false) &&
                        <Grid item md={6} sm={12}>
                          <Box p={1} style={{ borderRadius: '5px', border: '2px solid #ddd', }}>
                            <Typography variant='overline' sx={{ fontWeight: 'bold' }}>
                              Comprobante de seguro obligatorio en PDF
                            </Typography>
                            <Box pl={2} sx={{ display: 'inline' }}>
                              <Chip size="small"
                                label={this.state.data.archivo_soap_status ? 'Completo' : 'Incompleto'}
                                icon={(this.state.data.archivo_soap_status) ? <DoneIcon /> : <WarningIcon />}
                                style={(this.state.data.archivo_soap_status) ? { backgroundColor: 'lightgreen' } : {}}
                              />
                            </Box>
                            {this.state.data.archivo_soap &&
                              <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                <Typography variant='caption'>
                                  Actualmente ya tienes un archivo cargado&nbsp;
                                </Typography>
                                <Box>
                                  <Button startIcon={<DownloadIcon />}
                                    onClick={event => this.handleDownloadFile(event, this.state.data.archivo_soap)}
                                    variant='contained'>
                                    Descargar archivo
                                  </Button>
                                </Box>
                              </Box>
                            }
                            {this.state.html.edit &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) && ![1].includes(this.state.data.archivo_soap_validacion) &&
                              <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                <Typography variant='overline'>
                                  Subir/Actualizar (Archivo PDF o imagen):&nbsp;
                                </Typography>
                                <Box>
                                  <label htmlFor="encodedSoapFile">
                                    <Input name="encodedSoapFile"
                                      id="encodedSoapFile"
                                      type="file"
                                      accept="image/*,application/pdf"
                                      onChange={this.handleFile}
                                      style={{ display: 'none' }}
                                    />
                                    {'encodedSoapFile' in this.state.error && this.state.error.encodedSoapFile &&
                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                    }
                                    <Button startIcon={<UploadFileIcon />} variant='outlined' component="span">
                                      {this.state.data.encodedSoapFile !== '' && this.state.data.encodedSoapFile !== null ? 'Actualizar archivo' : 'Subir archivo'}
                                    </Button>
                                  </label>
                                </Box>
                              </Box>
                            }
                            {this.state.html.edit &&
                              this.state.data.archivo_soap &&
                              ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                              <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>

                                <FormControl component="fieldset">
                                  <FormLabel component="legend">Validar que el documento de Seguro Obligatorio es correcto</FormLabel>
                                  <RadioGroup aria-label="archivo_soap_validacion"
                                    name="archivo_soap_validacion"
                                    value={this.state.data.archivo_soap_validacion}
                                    onChange={this.handleRadioChange}
                                  >
                                    <FormControlLabel value={0} control={<Radio size="small" />} label="Aún sin validar" />
                                    <FormControlLabel value={1} control={<Radio size="small" />} label="Validado" />
                                    <FormControlLabel value={2} control={<Radio size="small" />} label="Rechazado" />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            }
                          </Box>
                        </Grid>
                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Box>



              {
                /*****************************************
                  Multas
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>

                    <Box p={1}>
                      <Alert severity={this.state.data.estado_multas === 0 ? 'warning' :
                        this.state.data.estado_multas === 1 ? 'success' :
                          this.state.data.estado_multas === 2 ? 'error' :
                            this.state.data.estado_multas === 3 ? 'info' :
                              'info'}
                        style={{ minHeigth: '100px' }}>
                        <Typography variant='h6'>
                          Multas
                        </Typography>

                        <Box>
                          {this.state.data.estado_multas === 0 ? <Box><strong>Estado sección: </strong> {' Pendiente a validación del Departamento de Tránsito Municipal.'}</Box> :
                            this.state.data.estado_multas === 1 ? <Box><strong>Estado sección: </strong> {' Todo en órden.'}</Box> :
                              this.state.data.estado_multas === 2 ? <Box><strong>Estado sección: </strong> {' Información rechazada.'}</Box> :
                                this.state.data.estado_multas === 3 ? <Box><strong>Estado sección: </strong> {' Información aún incompleta.'}</Box> :
                                  'info'}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_multas}
                        </Box>
                      </Alert>
                    </Box>

                    {this.state.data.multas && this.state.data.multas.length > 0 &&
                      <Box p={1}>
                        <Typography variant='overline' sx={{ fontWeight: 'Bold' }}>
                          {this.state.data.multas.length} multa{this.state.data.multas.length > 1 ? 's' : ''}
                        </Typography>
                        <TableContainer sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell padding='checkbox' />
                                <TableCell>#</TableCell>
                                <TableCell>Monto multa</TableCell>
                                <TableCell>Arancel</TableCell>
                                <TableCell>Comuna</TableCell>
                                <TableCell>Rol causa</TableCell>
                                <TableCell>Fecha infracción</TableCell>
                                <TableCell>Fecha sentencia</TableCell>
                                <TableCell>Pagada en otro lugar</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.data.multas.slice(this.paginaMultas() * MULTAS_POR_PAGINA, (this.paginaMultas() + 1) * MULTAS_POR_PAGINA).map((object, i) => {
                                // índice en this.state.data.multas (los handlers lo usan)
                                const index = this.paginaMultas() * MULTAS_POR_PAGINA + i;
                                return (
                                  <React.Fragment key={object.multa_en_permiso_uuid}>
                                    <TableRow sx={object.ya_pagada ? { '& > td': { borderBottom: 0 } } : {}}>
                                      <TableCell padding='checkbox'>
                                        {object.ya_pagada &&
                                          <IconButton size='small'
                                            title={this.state.multas_abiertas[object.multa_en_permiso_uuid] ? 'Ocultar comprobante' : 'Ver comprobante'}
                                            onClick={() => this.setState(prevState => ({
                                              multas_abiertas: {
                                                ...prevState.multas_abiertas,
                                                [object.multa_en_permiso_uuid]: !prevState.multas_abiertas[object.multa_en_permiso_uuid]
                                              }
                                            }))}
                                          >
                                            {this.state.multas_abiertas[object.multa_en_permiso_uuid] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                          </IconButton>
                                        }
                                      </TableCell>
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        {/* Formato chileno: miles con punto, decimales con coma; pesos sin decimales */}
                                        <NumberFormat displayType={'text'}
                                          value={Number(object.multa.monto)}
                                          thousandSeparator={'.'}
                                          decimalSeparator={','}
                                          decimalScale={object.multa.tipo_moneda === 1 ? 0 : 2}
                                          prefix={object.multa.tipo_moneda === 1 ? '$' : ''} />
                                        &nbsp;
                                        {object.multa.tipo_moneda === 2 ? 'UTM' : object.multa.tipo_moneda === 1 ? '' : 'UF'}
                                      </TableCell>
                                      <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <NumberFormat displayType={'text'}
                                          value={Number(object.multa.arancel)}
                                          thousandSeparator={'.'}
                                          decimalSeparator={','}
                                          decimalScale={0}
                                          prefix={'$'} />
                                      </TableCell>
                                      <TableCell>{object.multa.comuna}</TableCell>
                                      <TableCell>{object.multa.rol_causa}</TableCell>
                                      <TableCell>{(new Date(object.multa.fecha_infraccion)).toLocaleDateString('es-CL')}</TableCell>
                                      <TableCell>{(new Date(object.multa.fecha_sentencia)).toLocaleDateString('es-CL')}</TableCell>
                                      <TableCell>
                                        {this.state.html.edit &&
                                          ![4, 5, 6].includes(this.state.data.estado_consolidado) ?
                                          <FormControlLabel control={<Switch name='ya_pagada'
                                            id={object.multa_en_permiso_uuid}
                                            onChange={(event) => this.handleSwitchMultaChange(event, index)}
                                            checked={this.state.data.multas[index].ya_pagada}
                                          />}
                                            label={object.ya_pagada ? 'Sí' : 'No'} />
                                          :
                                          (object.ya_pagada ? 'Sí' : 'No')
                                        }
                                      </TableCell>
                                    </TableRow>
                                    {object.ya_pagada &&
                                      <TableRow>
                                        <TableCell colSpan={9} sx={{ py: 0 }}>
                                          <Collapse in={!!this.state.multas_abiertas[object.multa_en_permiso_uuid]} timeout='auto' unmountOnExit>
                                          {object.ya_pagada &&
                                            <Box>
                                              {object.ya_pagada_justificacion &&
                                                <Box p={1} style={{ background: '#eeeeff', borderRadius: '5px' }}>
                                                  <Typography variant='overline'>
                                                    Actualmente ya tienes un archivo cargado&nbsp;
                                                  </Typography>
                                                  <Button startIcon={<DownloadIcon />} onClick={event => this.handleDownloadFile(event, object.ya_pagada_justificacion)}>
                                                    Descargar archivo
                                                  </Button>
                                                </Box>
                                              }
                                              {this.state.html.edit &&
                                                ![4, 5, 6].includes(this.state.data.estado_consolidado) && this.state.data.multas[index].ya_pagada_validacion !== 1 &&
                                                <Box p={1} mt={1} style={{ background: '#e1e1ff', borderRadius: '5px' }}>
                                                  <Typography variant='overline'>
                                                    Subir/Actualizar comprobante de pago (Archivo PDF o imagen):&nbsp;
                                                  </Typography>

                                                  <Box>
                                                    <Typography variant='overline' sx={{ fontWeight: 'Bold' }}>
                                                      Subir uno nuevo archivo:&nbsp;
                                                    </Typography>
                                                    <input name="encodedMultaFile"
                                                      id={object.multa_en_permiso_uuid}
                                                      className='form-control'
                                                      type="file"
                                                      accept="image/*,application/pdf"
                                                      onChange={this.handleMultaFile} />

                                                    {String('encodedMultaFile' + '_' + object.multa_en_permiso_uuid) in this.state.error && this.state.error['encodedMultaFile' + '_' + object.multa_en_permiso_uuid] &&
                                                      <Box sx={{ color: 'red' }}>El archivo debe ser un PDF o imágen</Box>
                                                    }
                                                  </Box>

                                                </Box>
                                              }
                                              {this.state.html.edit &&
                                                object.ya_pagada && object.ya_pagada_justificacion &&
                                                ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                                                <Box p={1} mt={1} style={{ background: '#f1f1f1', borderRadius: '5px' }}>
                                                  <FormControl component="fieldset">
                                                    <FormLabel component="legend">Validar que el documento de multas es correcto</FormLabel>
                                                    <RadioGroup
                                                      aria-label="archivos_prt_validacion"
                                                      name="ya_pagada_validacion"
                                                      onChange={(event) => this.handleRadioMultaChange(event, index, object.multa_en_permiso_uuid)}
                                                      value={this.state.data.multas[index].ya_pagada_validacion}
                                                    >
                                                      <FormControlLabel value={0} control={<Radio />} label="Aún sin validar" />
                                                      <FormControlLabel value={1} control={<Radio />} label="Validado" />
                                                      <FormControlLabel value={2} control={<Radio />} label="Rechazado" />
                                                    </RadioGroup>
                                                  </FormControl>
                                                </Box>
                                              }
                                            </Box>
                                          }
                                          </Collapse>
                                        </TableCell>
                                      </TableRow>
                                    }
                                  </React.Fragment>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {this.state.data.multas.length > MULTAS_POR_PAGINA &&
                          <TablePagination component='div'
                            count={this.state.data.multas.length}
                            page={this.paginaMultas()}
                            rowsPerPage={MULTAS_POR_PAGINA}
                            rowsPerPageOptions={[]}
                            onPageChange={(event, pagina) => this.setState({ multas_pagina: pagina })}
                            labelDisplayedRows={({ from, to, count }) => from + '–' + to + ' de ' + count + ' multas'}
                          />
                        }
                      </Box>

                    }


                  </CardContent>
                </Card>
              </Box>
              {
                /*****************************************
                  Pago
                 ******************************************/
              }
              <Box mb={1}>
                <Card>
                  <CardContent>

                    <Box p={1}>
                      <Alert severity={this.state.data.estado_consolidado === 0 ? 'warning' :
                        this.state.data.estado_consolidado === 1 ? 'success' :
                          this.state.data.estado_consolidado === 2 ? 'error' :
                            this.state.data.estado_consolidado === 3 ? 'info' :
                              this.state.data.estado_consolidado === 4 ? 'success' :
                                this.state.data.estado_consolidado === 5 ? 'warning' :
                              this.state.data.estado_consolidado === 6 ? 'warning' :
                                  'info'}
                        style={{ minHeigth: '100px' }}
                        variant={[4, 5, 6].includes(this.state.data.estado_consolidado) ? 'filled' : 'standard'}>
                        <Typography variant='h6'>
                          Estado final del permiso
                        </Typography>
                        <Box>
                          <strong>Estado consolidado: </strong> {this.state.data.estado}
                        </Box>
                        <Box>
                          <strong>Comentario al contribuyente</strong>: {this.state.data.comentario_consolidado}
                        </Box>
                      </Alert>
                    </Box>
                    <Grid container>
                      {this.state.html.edit &&
                        ![4, 5, 6].includes(this.state.data.estado_consolidado) &&
                        <Grid item md={6} sm={12}>
                          {[1, 2, 3].includes(this.state.data.estado_consolidado) &&
                            <Box p={2}>
                              <TextField name='comentario'
                                id='comentario'
                                label='Antes de enviar el mail, puedes incluir un comentario al contribuyente'
                                placeholder='Comentario al contribuyente'
                                fullWidth
                                maxLength='1000'
                                value={this.state.comentario_notificacion}
                                onChange={this.handleInputChangeNotificacion}
                                variant="standard"
                              />
                            </Box>
                          }

                          <Box p={3}>
                            <FormControlLabel control={<Switch name='bloqueado'
                              id='bloqueado'
                              onChange={this.handleSwitchChange}
                              checked={this.state.data.bloqueado}
                            />}
                              label="Bloquear edición por parte del contribuyente" />
                          </Box>
                          <Box p={1}>
                            {this.state.data.estado_consolidado === 0 &&
                              <Box p={5} sx={{ borderRadius: '10px', border: "1px solid #DDDD55", backgroundColor: "#FFFFAA" }}>
                                <Typography variant='body2' >
                                  Cuándo hay secciones por validar o rechazar no es posible envíar notificaciones al contribuyente,
                                  ya que el agente aún tiene tareas faltantes.
                                </Typography>
                              </Box>
                            }
                            {(this.state.data.contribuyente.email === '' ||
                              this.state.data.contribuyente.email === null) &&
                              <Box p={5} sx={{ borderRadius: '10px', border: "1px solid #DDDD55", backgroundColor: "#FFFFAA" }}>
                                <Typography variant='body2' >
                                  Aún no hay ningún mail al cual mandar la notificación
                                </Typography>
                              </Box>
                            }
                            {this.state.data.estado_consolidado === 1 &&
                              this.state.data.contribuyente.email !== '' &&
                              this.state.data.contribuyente.email !== null &&
                              <Box p={1}>
                                <Box p={1}>
                                  <Button onClick={(event) => this.notificarEstado(event, 'permiso_para_pago')}
                                    variant='contained'
                                    startIcon={this.state.html.loading_notificacion ? <CircularProgress size={20} /> : <EmailIcon />}
                                    disabled={this.state.html.loading_notificacion ? true : false}
                                  >
                                    Notificar estado Listo para pago por mail
                                  </Button>
                                </Box>
                              </Box>
                            }
                            {this.state.data.estado_consolidado === 2 &&
                              this.state.data.contribuyente.email !== '' &&
                              this.state.data.contribuyente.email !== null &&
                              <Box p={1}>
                                <Box p={1}>
                                  <Button onClick={(event) => this.notificarEstado(event, 'permiso_con_rechazos')}
                                    variant='contained'
                                    startIcon={this.state.html.loading_notificacion ? <CircularProgress size={20} /> : <EmailIcon />}
                                    disabled={this.state.html.loading_notificacion ? true : false}
                                  >
                                    Notificar estado rechazado por mail
                                  </Button>
                                </Box>
                              </Box>
                            }
                            {this.state.data.estado_consolidado === 3 &&
                              this.state.data.contribuyente.email !== '' &&
                              this.state.data.contribuyente.email !== null &&
                              <Box p={1}>
                                <Box p={1}>
                                  <Button onClick={(event) => this.notificarEstado(event, 'permiso_con_pendientes')}
                                    variant='contained'
                                    startIcon={this.state.html.loading_notificacion ? <CircularProgress size={20} /> : <EmailIcon />}
                                    disabled={this.state.html.loading_notificacion ? true : false}
                                  >
                                    Notificar estado de datos incompletos por mail
                                  </Button>
                                </Box>
                              </Box>
                            }

                          </Box>
                        </Grid>
                      }
                      {this.state.data.notificaciones && this.state.data.notificaciones.length > 0 &&
                        <Grid item md={6} sm={12}>
                          <Typography variant="overline" sx={{ fontWeight: 'bold' }}>Notificaciones enviadas al contribuyente</Typography>
                          {this.state.data.notificaciones.map((notificacion) => {
                            return (
                              <Box m={1} p={1} sx={{ border: "1px solid #DDD" }} key={notificacion.notificacion_uuid}>
                                <Box>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Fecha envío:&nbsp;</Typography>
                                  <Typography variant="caption">
                                    {(new Date(notificacion.created_at)).toLocaleString('es-CL')}
                                  </Typography>
                                </Box>
                                <Box>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Estdo permiso:&nbsp;</Typography>
                                  <Typography variant="caption">{notificacion.estado_permiso}</Typography>
                                </Box>
                                <Box>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Comenterio al contribuyente:&nbsp;</Typography>
                                  <Typography variant="caption">{notificacion.comentario}</Typography>
                                </Box>
                                <Box>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Agente:&nbsp;</Typography>
                                  <Typography variant="caption">
                                    {notificacion.who !== null && notificacion.who !== '' ? notificacion.who : 'Sin agente identificable (notificación antigua)'}
                                  </Typography>
                                </Box>
                              </Box>
                            )
                          })}
                        </Grid>
                      }
                    </Grid>

                  </CardContent>
                </Card>
              </Box>


            </Box>
          }

        </Box>
      </Box>
    );
  }
}

export default withRouter(Permiso);